(function(){
  'use strict';

  function prefersReducedMotion(){
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initStickyHeaders(root){
    var headers = [];
    if(root.matches && root.matches('.site-header')) headers.push(root);
    root.querySelectorAll && root.querySelectorAll('.site-header').forEach(function(header){ headers.push(header); });

    headers.forEach(function(header){
      var wrapper = header.closest('.shopify-section') || header.parentElement;
      var enabled = header.getAttribute('data-sticky-header') !== 'false' && !header.classList.contains('site-header--static');
      if(wrapper) wrapper.classList.toggle('pawveylo-sticky-header-wrapper', enabled);
      if(header.dataset.stickyInitialized === 'true') return;
      header.dataset.stickyInitialized = 'true';
      function updateShadow(){ header.classList.toggle('is-scrolled', window.scrollY > 8); }
      updateShadow();
      window.addEventListener('scroll', updateShadow, { passive: true });
    });
  }

  function initMobileMenus(root){
    var menus = [];
    if(root.matches && root.matches('[data-mobile-menu]')) menus.push(root);
    root.querySelectorAll && root.querySelectorAll('[data-mobile-menu]').forEach(function(menu){ menus.push(menu); });

    menus.forEach(function(menu){
      if(menu.dataset.menuInitialized === 'true') return;
      menu.dataset.menuInitialized = 'true';
      menu.querySelectorAll('a').forEach(function(link){
        link.addEventListener('click', function(){ menu.removeAttribute('open'); });
      });
      document.addEventListener('click', function(event){
        if(menu.hasAttribute('open') && !menu.contains(event.target)) menu.removeAttribute('open');
      });
      document.addEventListener('keydown', function(event){
        if(event.key === 'Escape') menu.removeAttribute('open');
      });
    });
  }

  function initHeroSlider(slider){
    if(slider.dataset.heroInitialized === 'true') return;
    slider.dataset.heroInitialized = 'true';

    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-hero-slide]'));
    if(slides.length < 2) return;
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-hero-dot]'));
    var prev = slider.querySelector('[data-hero-prev]');
    var next = slider.querySelector('[data-hero-next]');
    var autoplay = slider.getAttribute('data-autoplay') === 'true' && !prefersReducedMotion();
    var interval = Math.max(3000, Number(slider.getAttribute('data-interval')) || 5000);
    var index = Math.max(0, slides.findIndex(function(slide){ return slide.classList.contains('is-active'); }));
    var timer = null;
    var paused = false;
    var touchStartX = 0;

    function show(newIndex){
      index = (newIndex + slides.length) % slides.length;
      slides.forEach(function(slide, slideIndex){
        var active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function(dot, dotIndex){
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function stop(){ if(timer){ window.clearInterval(timer); timer = null; } }
    function start(){
      stop();
      if(autoplay && !paused && !document.hidden) timer = window.setInterval(function(){ show(index + 1); }, interval);
    }
    function pause(){ paused = true; stop(); }
    function resume(){ paused = false; start(); }

    if(prev) prev.addEventListener('click', function(){ show(index - 1); start(); });
    if(next) next.addEventListener('click', function(){ show(index + 1); start(); });
    dots.forEach(function(dot){
      dot.addEventListener('click', function(){ show(Number(dot.getAttribute('data-hero-dot')) || 0); start(); });
    });
    slider.addEventListener('mouseenter', pause);
    slider.addEventListener('mouseleave', resume);
    slider.addEventListener('focusin', pause);
    slider.addEventListener('focusout', resume);
    slider.addEventListener('touchstart', function(event){
      pause();
      touchStartX = event.touches && event.touches[0] ? event.touches[0].clientX : 0;
    }, { passive: true });
    slider.addEventListener('touchend', function(event){
      var endX = event.changedTouches && event.changedTouches[0] ? event.changedTouches[0].clientX : touchStartX;
      var delta = endX - touchStartX;
      if(Math.abs(delta) > 45) show(index + (delta < 0 ? 1 : -1));
      window.setTimeout(resume, 1200);
    }, { passive: true });
    document.addEventListener('visibilitychange', start);
    show(index);
    start();
  }

  function initTestimonialSlider(slider){
    if(slider.dataset.testimonialInitialized === 'true') return;
    slider.dataset.testimonialInitialized = 'true';

    var viewport = slider.querySelector('[data-testimonial-viewport]');
    var track = slider.querySelector('[data-testimonial-track]');
    var cards = Array.prototype.slice.call(slider.querySelectorAll('[data-testimonial-slide]'));
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-testimonial-dot]'));
    var prev = slider.querySelector('[data-testimonial-prev]');
    var next = slider.querySelector('[data-testimonial-next]');
    if(!viewport || !track || cards.length < 2) return;

    var autoplay = slider.getAttribute('data-autoplay') === 'true' && !prefersReducedMotion();
    var pauseOnHover = slider.getAttribute('data-pause-hover') !== 'false';
    var interval = Math.max(3000, Number(slider.getAttribute('data-interval')) || 4000);
    var index = 0;
    var timer = null;
    var paused = false;
    var scrollTimer = null;

    function visibleCount(){
      if(!cards[0]) return 1;
      return Math.max(1, Math.round(viewport.clientWidth / cards[0].getBoundingClientRect().width));
    }
    function maxIndex(){ return Math.max(0, cards.length - visibleCount()); }
    function cardLeft(card){ return card.offsetLeft - track.offsetLeft; }
    function updateDots(){
      dots.forEach(function(dot, dotIndex){
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
    function goTo(newIndex, smooth){
      var max = maxIndex();
      if(newIndex > max) index = 0;
      else if(newIndex < 0) index = max;
      else index = newIndex;
      viewport.scrollTo({ left: cardLeft(cards[index]), behavior: smooth === false || prefersReducedMotion() ? 'auto' : 'smooth' });
      updateDots();
    }
    function nearestIndex(){
      var left = viewport.scrollLeft;
      var nearest = 0;
      var distance = Infinity;
      cards.forEach(function(card, cardIndex){
        var d = Math.abs(cardLeft(card) - left);
        if(d < distance){ distance = d; nearest = cardIndex; }
      });
      index = Math.min(nearest, maxIndex());
      updateDots();
    }
    function stop(){ if(timer){ window.clearInterval(timer); timer = null; } }
    function start(){
      stop();
      if(autoplay && !paused && !document.hidden) timer = window.setInterval(function(){ goTo(index + 1, true); }, interval);
    }
    function pause(){ paused = true; stop(); }
    function resume(){ paused = false; start(); }

    if(prev) prev.addEventListener('click', function(){ goTo(index - 1, true); start(); });
    if(next) next.addEventListener('click', function(){ goTo(index + 1, true); start(); });
    dots.forEach(function(dot){
      dot.addEventListener('click', function(){
        var requested = Number(dot.getAttribute('data-testimonial-dot')) || 0;
        goTo(Math.min(requested, maxIndex()), true);
        start();
      });
    });
    viewport.addEventListener('scroll', function(){
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(nearestIndex, 100);
    }, { passive: true });
    if(pauseOnHover){
      slider.addEventListener('mouseenter', pause);
      slider.addEventListener('mouseleave', resume);
      slider.addEventListener('focusin', pause);
      slider.addEventListener('focusout', resume);
      slider.addEventListener('touchstart', pause, { passive: true });
      slider.addEventListener('touchend', function(){ window.setTimeout(resume, 1200); }, { passive: true });
    }
    window.addEventListener('resize', function(){ goTo(Math.min(index, maxIndex()), false); });
    document.addEventListener('visibilitychange', start);
    updateDots();
    start();
  }

  function initScrollReveal(root){
    var candidates = [];
    var selector = '.benefit-card,.product-card,.story-grid,.section-head,.product-info-panel,.main-media,.product-accordion,.related-products-shell,.footer-grid';
    if(root.matches && root.matches(selector)) candidates.push(root);
    root.querySelectorAll && root.querySelectorAll(selector).forEach(function(element){ candidates.push(element); });
    candidates.forEach(function(element, index){
      if(element.dataset.revealInitialized === 'true') return;
      element.dataset.revealInitialized = 'true';
      element.classList.add('reveal-on-scroll');
      element.style.setProperty('--reveal-delay', ((index % 4) * 70) + 'ms');
    });

    if(prefersReducedMotion() || !('IntersectionObserver' in window)){
      candidates.forEach(function(element){ element.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function(entries, obs){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    candidates.forEach(function(element){ if(!element.classList.contains('is-visible')) observer.observe(element); });
  }

  function initQuantityControls(root){
    root.querySelectorAll('[data-qty-control]').forEach(function(control){
      if(control.dataset.quantityInitialized === 'true') return;
      control.dataset.quantityInitialized = 'true';
      var input = control.querySelector('input');
      control.querySelectorAll('[data-qty-change]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var change = Number(btn.getAttribute('data-qty-change')) || 0;
          var current = Number(input.value) || 1;
          var min = Number(input.getAttribute('min')) || 1;
          input.value = Math.max(min, current + change);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  function initProductPage(section){
    if(section.dataset.productInitialized === 'true') return;
    section.dataset.productInitialized = 'true';

    var variantJson = section.querySelector('[data-product-variants-json]');
    var variants = [];
    try { variants = JSON.parse(variantJson ? variantJson.textContent : '[]'); } catch(e) { variants = []; }

    var form = section.querySelector('.product-form');
    var idInput = section.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-product-price]');
    var compareEl = section.querySelector('[data-compare-price]');
    var addButton = section.querySelector('[data-add-button]');
    var inventory = section.querySelector('[data-inventory-note]');
    var mainMedia = section.querySelector('[data-main-media]');
    var mainImage = mainMedia ? mainMedia.querySelector('img') : null;
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-media-thumb]'));
    var prevButton = section.querySelector('[data-gallery-prev]');
    var nextButton = section.querySelector('[data-gallery-next]');
    var counter = section.querySelector('[data-gallery-current]');
    var activeIndex = Math.max(0, thumbs.findIndex(function(thumb){ return thumb.classList.contains('is-active'); }));
    var touchStartX = 0;
    var touchStartY = 0;

    function updateCounter(){
      if(counter) counter.textContent = String(activeIndex + 1);
    }

    function swapImage(src, alt){
      if(!mainImage || !src) return;
      var change = function(){
        mainImage.removeAttribute('srcset');
        mainImage.setAttribute('src', src);
        if(alt) mainImage.setAttribute('alt', alt);
        if(mainMedia) mainMedia.classList.remove('is-changing');
      };
      if(mainMedia && section.classList.contains('product-page--motion') && !prefersReducedMotion()){
        mainMedia.classList.add('is-changing');
        window.setTimeout(change, 120);
      } else {
        change();
      }
    }

    function activateThumb(index, shouldScroll){
      if(!thumbs.length) return;
      activeIndex = (index + thumbs.length) % thumbs.length;
      thumbs.forEach(function(thumb, thumbIndex){
        var active = thumbIndex === activeIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      var activeThumb = thumbs[activeIndex];
      var fullSrc = activeThumb.getAttribute('data-full-src');
      var thumbImage = activeThumb.querySelector('img');
      swapImage(fullSrc, thumbImage ? thumbImage.getAttribute('alt') : '');
      updateCounter();
      if(shouldScroll !== false && activeThumb.scrollIntoView){
        activeThumb.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    function showMediaById(mediaId, imageSrc){
      var matchingIndex = thumbs.findIndex(function(thumb){
        return mediaId && String(thumb.getAttribute('data-media-id')) === String(mediaId);
      });
      if(matchingIndex >= 0) activateThumb(matchingIndex, true);
      else if(imageSrc) swapImage(imageSrc, '');
    }

    thumbs.forEach(function(thumb, thumbIndex){
      thumb.addEventListener('click', function(){ activateThumb(thumbIndex, true); });
    });
    if(prevButton) prevButton.addEventListener('click', function(){ activateThumb(activeIndex - 1, true); });
    if(nextButton) nextButton.addEventListener('click', function(){ activateThumb(activeIndex + 1, true); });

    if(mainMedia && thumbs.length > 1){
      mainMedia.addEventListener('keydown', function(event){
        if(event.key === 'ArrowLeft'){ event.preventDefault(); activateThumb(activeIndex - 1, true); }
        if(event.key === 'ArrowRight'){ event.preventDefault(); activateThumb(activeIndex + 1, true); }
      });
      if(section.getAttribute('data-gallery-swipe') === 'true'){
        mainMedia.addEventListener('touchstart', function(event){
          var touch = event.touches && event.touches[0];
          touchStartX = touch ? touch.clientX : 0;
          touchStartY = touch ? touch.clientY : 0;
        }, { passive: true });
        mainMedia.addEventListener('touchend', function(event){
          var touch = event.changedTouches && event.changedTouches[0];
          var endX = touch ? touch.clientX : touchStartX;
          var endY = touch ? touch.clientY : touchStartY;
          var deltaX = endX - touchStartX;
          var deltaY = endY - touchStartY;
          if(Math.abs(deltaX) > 45 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2){
            activateThumb(activeIndex + (deltaX < 0 ? 1 : -1), true);
          }
        }, { passive: true });
      }
    }

    function selectedOptions(){
      var groups = section.querySelectorAll('[data-option-group]');
      return Array.prototype.map.call(groups, function(group){
        var checked = group.querySelector('[data-option-input]:checked');
        var select = group.querySelector('select[data-option-input]');
        return checked ? checked.value : (select ? select.value : null);
      });
    }

    function findVariant(options){
      return variants.find(function(variant){
        return variant.options.every(function(option, optionIndex){ return option === options[optionIndex]; });
      });
    }

    function updateVariant(){
      if(!variants.length) return;
      var variant = findVariant(selectedOptions());
      if(!variant){
        if(addButton){ addButton.disabled = true; addButton.textContent = 'Unavailable'; }
        if(inventory){ inventory.textContent = 'This combination is unavailable'; inventory.className = 'inventory-note unavailable'; }
        return;
      }
      if(idInput) idInput.value = variant.id;
      if(priceEl) priceEl.textContent = variant.price;
      if(compareEl){
        if(variant.compareAtPrice){ compareEl.textContent = variant.compareAtPrice; compareEl.style.display = 'inline'; }
        else { compareEl.textContent = ''; compareEl.style.display = 'none'; }
      }
      if(addButton){
        addButton.disabled = !variant.available;
        var addLabel = addButton.getAttribute('data-add-label') || 'Add to cart';
        var soldLabel = addButton.getAttribute('data-sold-out-label') || 'Sold out';
        addButton.textContent = variant.available ? addLabel : soldLabel;
      }
      if(inventory){
        var availableText = inventory.getAttribute('data-available-text') || 'In stock — ready for secure checkout';
        var soldOutText = inventory.getAttribute('data-sold-out-text') || 'Currently sold out';
        inventory.textContent = variant.available ? availableText : soldOutText;
        inventory.className = 'inventory-note ' + (variant.available ? 'available' : 'unavailable');
      }
      if(variant.imageId || variant.imageSrc) showMediaById(variant.imageId, variant.imageSrc);
      if(window.history && window.history.replaceState){
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    section.querySelectorAll('[data-option-input]').forEach(function(input){ input.addEventListener('change', updateVariant); });
    if(form) form.addEventListener('submit', updateVariant);
    updateCounter();
    updateVariant();
  }

  function initThemeRoot(root){
    initStickyHeaders(root);
    initMobileMenus(root);
    initQuantityControls(root);
    initScrollReveal(root);
    if(root.matches && root.matches('[data-product-section]')) initProductPage(root);
    root.querySelectorAll && root.querySelectorAll('[data-product-section]').forEach(initProductPage);
    if(root.matches && root.matches('[data-hero-slider]')) initHeroSlider(root);
    root.querySelectorAll && root.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);
    if(root.matches && root.matches('[data-testimonial-slider]')) initTestimonialSlider(root);
    root.querySelectorAll && root.querySelectorAll('[data-testimonial-slider]').forEach(initTestimonialSlider);
  }

  document.addEventListener('DOMContentLoaded', function(){ initThemeRoot(document); });
  document.addEventListener('shopify:section:load', function(event){ initThemeRoot(event.target); });
  document.addEventListener('shopify:block:select', function(event){
    var heroSlide = event.target.closest && event.target.closest('[data-hero-slide]');
    if(heroSlide){
      var hero = heroSlide.closest('[data-hero-slider]');
      var dot = hero && hero.querySelector('[data-hero-dot="' + heroSlide.getAttribute('data-slide-index') + '"]');
      if(dot) dot.click();
    }
    var review = event.target.closest && event.target.closest('[data-testimonial-slide]');
    if(review){
      var reviewSlider = review.closest('[data-testimonial-slider]');
      var reviewDot = reviewSlider && reviewSlider.querySelector('[data-testimonial-dot="' + review.getAttribute('data-slide-index') + '"]');
      if(reviewDot) reviewDot.click();
    }
  });
})();
